import { FundraisingFund } from '../../types';
import VDRActivityPanel from '../../components/Fundraising/VDRActivityPanel';

interface FundVDRActivityProps {
  fund: FundraisingFund;
}

export default function FundVDRActivity({ fund }: FundVDRActivityProps) {
  return (
    <div className="space-y-6">
      {/* VDR Activity */}
      <VDRActivityPanel fundId={fund.id} />
    </div>
  );
}
